import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IShortLink, IShortLinkForm } from "../models/shortlink";

@Injectable({
  providedIn: "root",
})
export class ShortLinksService {
  constructor(private _httpClient: HttpClient) {}

  //lista degli shortlink
  async getShortLinks() {
    return this._httpClient.get<IShortLink[]>("/shortlink").toPromise();
  }

  //singolo shortlink
  async getShortLink(id: string) {
    return this._httpClient.get("/shortlink/" + id).toPromise();
  }

  //modifica shortolink
  async editShortLink(id: string, data: IShortLinkForm) {
    return this._httpClient.put("/shortlink/" + id, data).toPromise();
  }

  //aggiungi shortlink
  async createShortLink(data: IShortLinkForm) {
    return this._httpClient.post("/shortlink", data).toPromise();
  }

  //elimina shortlink
  async deleteShortLink(id: string) {
    return this._httpClient.delete("/shortlink/" + id).toPromise();
  }

  //numero click
  getClickShortLink(id: string) {
    return this._httpClient.get("/shortlink-click/" + id).toPromise();
  }
}
